var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"store-badge",attrs:{"target":"_blank","href":_vm.appUrl}},[_c('img',{staticClass:"appstore",style:(("width: " + _vm.width)),attrs:{"alt":_vm.altText,"src":_vm.badgeUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }